module.exports = __webpack_public_path__ + "static/media/Guide_Conecta_Tracking.0141dfb0.pdf";